import { createRouter, createWebHistory } from "vue-router";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import Home from "../pages/Home.vue";
import Privacy from "../pages/Privacy.vue";
import Contattaci from "../pages/Contattaci.vue";
import CancellazioneDati from "../pages/CancellazioneDati.vue";

const routes = [
  {
    path: "/app",
    redirect: { path: "/", hash: "download" },
  },
  {
    path: "/",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
      },
      {
        path: "privacy",
        name: "Privacy",
        component: Privacy,
      },
      {
        path: "contattaci",
        name: "Contattaci",
        component: Contattaci,
      },
      {
        path: "cancellazione-dati",
        name: "CancellazioneDati",
        component: CancellazioneDati,
      },
      {
        path: "delete-account",
        redirect: { name: "CancellazioneDati" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    } else {
      return { top: 0 };
    }
  },
});

export default router;
